import React, { useState, useContext, }from 'react'
import { Row, Col, Form, Select, Input } from 'antd'
import { EditSerialNumberModal } from '../../../Modals/EditSerialNumberModal.component';
import { Card } from '../../../../UI/Card/Card.component'
import { DeviceButtonGroup } from '../DeviceButtonGroup.component';
import { getDeviceTitle } from '../DevicesList/DevicesList.component';
import { DeviceForm } from '../DeviceForm.component';
import { DeviceRestrictedInput } from '../DeviceRestrictedInput.component';
import { StationContext } from '../../../../../context/station-context';
import { EditSerialNumButton } from '../EditSerialNumButton.component';

const { Option } = Select;

export const LTE = ({ device, serialNum, isPanelPending, onSaveHandler, ...props }) => {

    const [stationState, stationDispatch] = useContext(StationContext)

    const [form] = Form.useForm();
    const [displayModal, setDisplayModal] = useState(false);

    const valuesChangeHandler = (changedValues, allValues) => {
        Object.assign(allValues, {id: device.id, status: device.status, deviceType: device.deviceType});
        stationDispatch({
            type: 'ADD_PENDING_QUEUE', 
            payload: allValues,
        })
    }

    return (
        <>
            <div className="device__LTE">
                <Row>
                    <Col flex={1}>
                        <Card bordered={true}>
                            <DeviceForm
                                name={`LTE-${device.id}-device-form`}
                                form={form}
                                layout="vertical"
                                initialValues={device}
                                onValuesChange={(changedValues, allValues) => valuesChangeHandler(changedValues, allValues)}
                                onFinish={() => onSaveHandler([device.id])}
                                >
                                <div className='form__layout--vertical-inline'>
                                    <EditSerialNumButton
                                        serialNum={serialNum}
                                        devicePending={isPanelPending(device)}
                                        onClick={() => setDisplayModal(true)}
                                    />
                                    <Form.Item label='VPN Mode:' name='licensed'>
                                        <Select>
                                            <Option value={0}>OFF</Option>
                                            <Option value={1}>ON</Option>
                                        </Select>
                                    </Form.Item>
                                    <DeviceRestrictedInput label='Firmware Version:' name='version'>
                                        <Input disabled/>
                                    </DeviceRestrictedInput>
                                    <DeviceRestrictedInput label='OS Version:' name='routerversion'>
                                        <Input disabled/>
                                    </DeviceRestrictedInput>
                                    <DeviceRestrictedInput label='LTE Month Bytes:' name='lteMonthBytes'>
                                        <Input disabled/>
                                    </DeviceRestrictedInput>
                                    <DeviceRestrictedInput label='LTE Day Bytes:' name='lteDayBytes'>
                                        <Input disabled/>
                                    </DeviceRestrictedInput>
                                    <DeviceRestrictedInput label='LTE Ether Jack MAC:' name='lteEtherJackMAC'>
                                        <Input disabled/>
                                    </DeviceRestrictedInput>
                                    <DeviceRestrictedInput label='LTE Signal:' name='lteSignal'>
                                        <Input disabled/>
                                    </DeviceRestrictedInput>
                                    <DeviceRestrictedInput label='LTE Up Time:' name='lteUpTime'>
                                        <Input disabled/>
                                    </DeviceRestrictedInput>
                                    <DeviceRestrictedInput label='LTE Provider:' name='lteProvider'>
                                        <Input disabled/>
                                    </DeviceRestrictedInput>
                                    <DeviceRestrictedInput label='LTE IMEI:' name='lteIMEI'>
                                        <Input disabled/>
                                    </DeviceRestrictedInput>
                                    <DeviceRestrictedInput label='LTE UICC:' name='lteUICC'>
                                        <Input disabled/>
                                    </DeviceRestrictedInput>
                                </div>
                                <Row justify='space-between' style={{minWidth: '100%'}}>
                                    <DeviceButtonGroup serialNum={serialNum} status={device.status} ant winbox/>
                                </Row>
                            </DeviceForm>
                        </Card>
                    </Col>
                </Row>
            </div>
            <EditSerialNumberModal displayField={false} id={device.id} deviceType={getDeviceTitle(device.deviceType)} serialNum={device.serialNum} visible={displayModal} setVisible={setDisplayModal} />
        </>
    )

}